import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let KeyValueComp;

class Key_value_pair extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: KeyValueComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/zcat-components/key-value-comp" */
      "../../../components/javascript/zcat-components/key-value-comp"
    ).then(function(res) {
      KeyValueComp = res.KeyValueComp;
    }));

    
;
  }
}

export { Key_value_pair };
